<template>
<div id="pageTable">
    <v-container grid-list-xl fluid>
        <v-card>
            <v-layout class="d-flex flex-lg-row flex-md-column flex-sm-column" wrap pa-3>
                <v-flex lg4 md4 sm12>
                    <h-currency-input v-model="configuration.Currency" label="Tỷ giá CNY" :decimal="0" class="input-group--focused"></h-currency-input>
                </v-flex>
                <v-flex lg8 md8 sm12>
                </v-flex>
                <!-- <v-flex lg4 md4 sm12>
                    <h-currency-input label="Giá cân gốc" v-model="configuration.WeightPrice" :decimal="0" class="input-group--focused"></h-currency-input>
                </v-flex>
                <v-flex lg4 md4 sm12>
                    <h-currency-input label="Giá khối gốc" v-model="configuration.VolumePrice" :decimal="0" class="input-group--focused"></h-currency-input>
                </v-flex> -->
            </v-layout>
        </v-card>
    </v-container>
</div>
</template>

<script>
import {
    mapState
} from "vuex";

export default {
    computed: {
        ...mapState({
            loading: state => state.configuration.loading,
            configuration: state => state.configuration.selected
        })
    },
    methods: {
        refreshData() {
            this.$store.dispatch("configuration/getDetail", 1);
        },
        saveData() {
            this.$store.dispatch("configuration/setDetail", {
                data: this.configuration,
                id: this.configuration.ID
            });
        },
    },
    mounted() {
        this.refreshData();
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
        if (this.$route.query.uid && this.$route.query.uid !== '') {
            this.configuration.UID = Number(this.$route.query.uid);
        }
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
    },
};
</script>

<style>
</style>
